import { cn } from '@/lib/cn';
import { LoaderCircle } from 'lucide-react';

interface LoaderProps {
  className?: string;
}

function Loader({ className }: LoaderProps) {
  return (
    <LoaderCircle className={cn('text-primary-100 animate-spin', className)} />
  );
}

export { Loader };
